export default __webpack_public_path__ + "static/media/febo_logo.cb0a1eb9.webp";